module.exports = __webpack_public_path__ + "static/media/W5390484_3.ed3c9049.jpg";